import "./App.css";
import NavBar from "./component/NavBar";
import BodyContent from "./component/BodyContent";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Terms from "./component/Terms";
import Policy from "./component/Policy";
import ThankYouScreen from "./component/ThankYouScreen";
import Raheja from "./projects/Raheja";
import TodayGlobal from "./projects/Today_Global";
import Arihant from "./projects/Arihant";
import Kamdhenu from "./projects/Kamdhenu";
import Tricity from "./projects/Tricity";
import Paradise from "./projects/Paradise";
import Godrej from "./projects/Godrej";
import Chatbot from "./component/Chatbot";
import Siddharth from "./projects/Siddharth";
import Hiranandani from "./projects/Hiranandani";
import Satyam from "./projects/Satyam";
import Lodha from "./projects/Lodha";

const App = () => {
  return (
    <Router>
      <MainApp />
    </Router>
  );
};

const MainApp = () => {
  // const location = useLocation();

  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<BodyContent />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/thank-you" element={<ThankYouScreen />} />
        <Route path="/raheja" element={<Raheja />} />
        <Route path="/today-global" element={<TodayGlobal />} />
        <Route path="/arihant" element={<Arihant />} />
        <Route path="/kamdhenu" element={<Kamdhenu />} />
        <Route path="/tricity" element={<Tricity />} />
        <Route path="/paradise" element={<Paradise />} />
        <Route path="/godrej" element={<Godrej />} />
        <Route path="/siddharth-builders" element={<Siddharth />} />
        <Route path="/today-global" element={<TodayGlobal />} />
        <Route path="/hiranandani" element={<Hiranandani />} />
        <Route path="/satyam" element={<Satyam />} />
        <Route path="/lodha" element={<Lodha />} />
      </Routes>
      {/* {location.pathname !== "/thank-you" && <Footer />} */}
      <Chatbot />
    </>
  );
};
export default App;
